export default __webpack_public_path__ + "static/rovo-overlay-remix-light-e9acd8a99352eb15da30a283253e7948.png";